import * as Sentry from "@sentry/react";

import { portalEnv } from "./portalEnv";

// @ts-expect-error
const commitHash = COMMITHASH;
const sentryEnabled = portalEnv.SENTRY_ENABLED;
const sentryEnv = portalEnv.SENTRY_ENV;
if (sentryEnabled && sentryEnv && commitHash) {
  const dsn = portalEnv.SENTRY_DSN;
  Sentry.init({
    dsn,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    release: commitHash,
    environment: sentryEnv,

    beforeSend: (event, hint) => {
      const error: any = hint.originalException;
      if (error?.code === "ECONNABORTED" || error?.code === "ERR_NETWORK") {
        return null;
      }
      return event;
    },
  });
}
